import { gql } from '@apollo/client';

export const GET_PRODUCT = gql`
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      title
      subtitle
      isbn
      author
      thumbnail
      description
      pages
      publisher
      edition
      affiliateProducts {
        id
        link
        affiliate {
          id
          name
          image
        }
      }
    }
  }
`;

export const LIST_SIMILAR_PRODUCTS = gql`
  query ListSimilarProducts($productId: ID!, $pagination: Pagination) {
    listSimilarProducts(productId: $productId, pagination: $pagination) {
      id
      title
      subtitle
      isbn
      author
      thumbnail
      pages
      publisher
      edition
    }
  }
`;

export const LIST_BOOKS = gql`
  query ListBooks($productId: ID!, $pagination: Pagination, $sorting: Sorting) {
    listBooks(
      productId: $productId
      pagination: $pagination
      sorting: $sorting
    ) {
      id
      title
      subtitle
      author
      price
      comment
      createdAt
      updatedAt
      user {
        id
        name
      }
    }
  }
`;

export const CREATE_PRODUCT_VISIT = gql`
  mutation CreateProductVisit($input: ProductVisitInput!) {
    createProductVisit(input: $input)
  }
`;
